import { S as r } from "../scrollbar2-f7c66394.js";
import { w as o } from "../util-b2b0dc25.js";
import "vue";
import "../assets/utils/scrollbar-width.js";
import "../assets/utils/dom.js";
import "./util.js";
const s = o(r);
export {
  s as default
};
